export function slugifyVehiclePart(value) {
  if (value === null || value === undefined) return "";

  return String(value)
    .trim()
    .toLowerCase()
    .replace(/['\u2019]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function normalizeForModelTrimComparison(value) {
  return comparisonTokens(value).map((token) => token.toLowerCase()).join(" ");
}

export function removeLeadingModelFromTrim(model, trim) {
  const normalizedModel = normalizeForModelTrimComparison(model);
  const normalizedTrim = normalizeForModelTrimComparison(trim);

  if (!normalizedModel || !normalizedTrim) return trim;
  if (normalizedTrim === normalizedModel) return "";
  if (!normalizedTrim.startsWith(`${normalizedModel} `)) return trim;

  const trimTokens = comparisonTokens(trim);
  const modelTokenCount = comparisonTokens(model).length;
  return trimTokens.length > modelTokenCount ? trimTokens.slice(modelTokenCount).join(" ") : "";
}

function comparisonTokens(value) {
  return String(value ?? "").match(/[a-z0-9]+/gi) ?? [];
}

export function buildVehicleSlug(vehicle = {}) {
  const make = vehicle.nhtsaMake ?? vehicle.NhtsaMake ?? vehicle.NHTSAMake ?? vehicle.make;
  const model = vehicle.nhtsaModel ?? vehicle.NhtsaModel ?? vehicle.NHTSAModel ?? vehicle.model;
  const trim = removeLeadingModelFromTrim(
    model,
    vehicle.nhtsaTrim ?? vehicle.NhtsaTrim ?? vehicle.NHTSATrim ?? vehicle.trim
  );
  const parts = [
    vehicle.year,
    make,
    model,
    trim,
    vehicle.dealerCity ?? vehicle.city,
    vehicle.dealerState ?? vehicle.state,
  ];

  return parts.map(slugifyVehiclePart).filter(Boolean).join("-");
}

export function getVehiclePath(vehicleOrId) {
  const hasVehicleObject = typeof vehicleOrId === "object" && vehicleOrId !== null;
  const vehicle = hasVehicleObject ? vehicleOrId : { id: vehicleOrId };

  const id = vehicle.id ?? vehicle.carId;
  if (id === null || id === undefined || id === "") return "";

  const slug = buildVehicleSlug(vehicle);
  if (hasVehicleObject && !slug) return `/car/${encodeURIComponent(id)}/vehicle`;
  return slug ? `/car/${encodeURIComponent(id)}/${slug}` : `/car/${encodeURIComponent(id)}`;
}

export function getVehicleCanonicalUrl(vehicleOrId, origin = "https://meshum.com") {
  const path = getVehiclePath(vehicleOrId);
  return path ? `${origin.replace(/\/+$/, "")}${path}` : "";
}
